import { getData, postData, putData, deleteData } from "../apiClient";

// ─── Paginated list ───────────────────────────────────────────────────────────

export const getBlogCategoriesWithPagination = async ({ page = 1, limit = 10, search = "" }, signal = null) => {
    try {
        const queryParams = new URLSearchParams({ page: String(page), limit: String(limit), search });
        const result = await getData(`/blog-category/?${queryParams}`, {}, {}, signal);
        return { success: true, ...result };
    } catch (error) {
        console.error("Get Blog Categories pagination API error:", error);
        return { success: false, ...error };
    }
};

// ─── Dropdown (no pagination) ─────────────────────────────────────────────────

export const getBlogCategoryDropdown = async () => {
    try {
        const result = await getData(`/blog-category/dropdown`);
        return { data: { success: true, ...result } };
    } catch (error) {
        console.error("Get Blog Category dropdown API error:", error);
        return { data: { success: false, error: error.message } };
    }
};

// ─── Single record ────────────────────────────────────────────────────────────

export const getBlogCategoryById = async (id) => {
    try {
        const result = await getData(`/blog-category/${id}`);
        return { data: { success: true, ...result } };
    } catch (error) {
        return { data: { success: false, error: error.message } };
    }
};

// ─── Create ───────────────────────────────────────────────────────────────────

export const createBlogCategory = async ({ data }) => {
    try {
        const result = await postData(`/blog-category/create-category`, data);
        return { data: { success: true, data: result } };
    } catch (error) {
        return { data: { success: false, error: error.status === 400 ? error.data?.error : error.message, status: error.status } };
    }
};

// ─── Update ───────────────────────────────────────────────────────────────────

export const updateBlogCategory = async ({ id, data }) => {
    try {
        const result = await putData(`/blog-category/update-category/${id}`, data);
        return { data: { success: true, data: result } };
    } catch (error) {
        return { data: { success: false, error: error.status === 400 ? error.data?.error : error.message, status: error.status } };
    }
};

// ─── Delete ───────────────────────────────────────────────────────────────────

export const deleteBlogCategory = async ({ id }) => {
    try {
        const result = await deleteData(`/blog-category/delete-category/${id}`);
        return { data: { success: true, data: result } };
    } catch (error) {
        return { data: { success: false, error: error.message, status: error.status } };
    }
};
